package com.eladfinish.bible.contest.screens.settings.ui.components.model

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.browse_and_complete_chapter
import com.eladfinish.bible.contest.multiple_choice_questions
import com.eladfinish.bible.contest.open_questions
import com.eladfinish.bible.contest.pair_matching
import com.eladfinish.bible.contest.title_random_verse
import com.eladfinish.bible.contest.title_settings_format
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import dev.icerock.moko.resources.format
import kotlinx.serialization.Serializable

@Serializable
enum class SubSettingsComponentType(
    private val titleRes: StringResource,
) {
    RANDOM_VERSE_SETTINGS(SharedRes.strings.title_random_verse),
    CHAPTER_COMPLETE_SETTINGS(SharedRes.strings.browse_and_complete_chapter),
    PAIR_MATCHING_SETTINGS(SharedRes.strings.pair_matching),
    OPEN_QUESTIONS_SETTINGS(SharedRes.strings.open_questions),
    AMERICAN_QUESTIONS_SETTINGS(SharedRes.strings.multiple_choice_questions),
    ;

    val title: StringDesc
        get() = titleRes.desc()

    val subtitle: StringDesc
        get() = SharedRes.strings.title_settings_format.format(titleRes.desc())
}
